/**
 * Data Model Visualization Component
 * 
 * Simplified component that displays only the database schema visualization.
 * Shows technical schema relationships and data architecture.
 */

import React, { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Database, ChevronDown, ChevronUp } from 'lucide-react';
import SchemaVisualization from '@/components/data-model/SchemaVisualization';
import SchemaInfoPanel from '@/components/data-model/SchemaInfoPanel';

export default function DataModelVisualization() {
  const [showDataModel, setShowDataModel] = useState(true);

  return (
    <div className="space-y-6">
      {/* Data Model Schema Visualization */}
      <Card className="overflow-hidden">
        <div className="p-4 border-b">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <Database className="w-5 h-5 text-blue-600" />
              <div>
                <h3 className="text-lg font-semibold">Data Model Schema</h3>
                <p className="text-sm text-muted-foreground">
                  Technical architecture showing entity relationships, schemas, and data engineering design
                </p>
              </div>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={() => setShowDataModel(!showDataModel)}
              className="flex items-center space-x-1"
            >
              {showDataModel ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
              <span>{showDataModel ? 'Hide' : 'Show'}</span>
            </Button>
          </div>
        </div>

        {showDataModel && (
          <>
            <SchemaInfoPanel />
            <SchemaVisualization isVisible={showDataModel} />
          </>
        )}
      </Card>
    </div>
  );
}
